/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import cc from 'classnames';

import { socialLinks } from 'utils/constants';
import styles from './SocialMedia.module.css';

import instagram from 'assets/icons/instagram.png';
import linkedin from 'assets/icons/linkedin.png';
import facebook from 'assets/icons/facebook.png';
import twitter from 'assets/icons/twitter.png';

const SocialMedia = () => (
  <div className={styles.wrapper}>
    <div className={styles.linkIconContainer}>
      <a href={socialLinks.facebook} className={styles.link} target="_blank" rel="noreferrer">
        <img src={facebook} alt="facebook" className={styles.icon} />
      </a>
    </div>
    <div className={styles.linkIconContainer}>
      <a href={socialLinks.twitter} className={styles.link} target="_blank" rel="noreferrer">
        <img src={twitter} alt="twitter" className={styles.icon} />
      </a>
    </div>
    <div className={styles.linkIconContainer}>
      <a href={socialLinks.instagram} className={styles.link} target="_blank" rel="noreferrer">
        <img src={instagram} alt="instagram" className={styles.icon} />
      </a>
    </div>
    <div className={styles.linkIconContainer}>
      <a href={socialLinks.linkedin} className={styles.link} target="_blank" rel="noreferrer">
        <img src={linkedin} alt="linkedin" className={styles.icon} />
      </a>
    </div>
    <span className={cc(styles.link, styles.text)}>@firstatlanticgh</span>
  </div>
);

export default SocialMedia;
